export const imageCard2 = require('./img-2.jpg');
export const imageCard3 = require('./img-3.jpg');
export const imageCard4 = require('./img-4.jpg');
export const imageCard5 = require('./img-5.jpg');
export const imageCard6 = require('./img-6.jpg');
export const imageCard7 = require('./img-7.jpg');
export const imageCard8 = require('./img-8.jpg');
export const imageCard9 = require('./img-9.jpg');
